// src/components/..../Avatar.js (place it in a logical components folder)

import React from 'react';

// A simple array of colors for the avatars
const avatarColors = [
    '#FFC107', '#FF5722', '#F44336', '#E91E63', '#9C27B0',
    '#673AB7', '#3F51B5', '#2196F3', '#00BCD4', '#009688',
    '#4CAF50', '#8BC34A', '#CDDC39', '#795548', '#607D8B'
];

// This function generates initials from a name (e.g., "Michael Jones" -> "MJ")
const getInitials = (name = '') => {
    if (!name) return '?';
    const words = name.split(' ');
    if (words.length > 1) {
        return `${words[0][0]}${words[words.length - 1][0]}`.toUpperCase();
    }
    return `${words[0][0]}`.toUpperCase();
};

const Avatar2 = ({ name }) => {
    const initials = getInitials(name);
    
    // Pick a deterministic color based on the first letter of the name
    const colorIndex = name ? name.charCodeAt(0) % avatarColors.length : 0;
    const backgroundColor = avatarColors[colorIndex];

    const style = {
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        backgroundColor: backgroundColor,
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '16px',
        fontWeight: 'bold',
        fontFamily: 'sans-serif',
    };

    return (
        <div style={style}>
            {initials}
        </div>
    );
};

export default Avatar2;